import type { ReactNode } from 'react'

export const TinyBox = ({
  children,
  title,
  actionComponent,
}: {
  children: ReactNode
  title?: string
  actionComponent?: ReactNode
}) => {
  return (
    <div className="ap:bg-[#FFFFFF] ap:relative ap:rounded-lg ap:border ap:border-content-disabled ap:px-xl ap:py-md ap:h-fit ap:flex ap:flex-row ap:w-full ap:justify-between">
      <div className="ap:flex ap:flex-col ap:gap-xs">
        {title && <h3 className="ap:text-lg ap:font-semibold">{title}</h3>}
        {children}
      </div>
      {actionComponent && actionComponent}
    </div>
  )
}
